import { Comment } from "@mui/icons-material";
import { Badge, BadgeProps, IconButton, Tooltip, styled } from "@mui/material";
import MembersOnlyJacket from "components/MembersOnlyJacket";
import ENTITY_TYPE from "enums/ENTITY_TYPE";
import useGlobalModal from "features/ModalManagement/hooks/useGlobalModal";
import useGetEntityNotes from "hooks/api/useGetEntityNotes";
import useGetParticipantById from "hooks/api/useGetParticipantById";
import { getPluralized } from "utils/display";
import EntityNotes from "./components/EntityNotes";

interface Props {
  participantId?: string;
}

const StyledBadge = styled(Badge)<BadgeProps>(({ theme }) => ({
  "& .MuiBadge-badge": {
    right: 10,
    top: 10,
    border: `2px solid ${theme.palette.background.paper}`,
    padding: "0 4px",
  },
}));

export default function RespondentNotes({ participantId }: Props) {
  const { participant } = useGetParticipantById(participantId);
  const { setModalContent } = useGlobalModal();
  const { notes } = useGetEntityNotes(ENTITY_TYPE.PARTICIPANT, participantId);

  return (
    participantId && (
      <MembersOnlyJacket>
        <Tooltip
          title={`${participant?.firstName}${participant?.lastName ? ` ${participant.lastName.charAt(0)}.` : ""} has ${getPluralized("note", notes?.length || 0)}`}
        >
          <StyledBadge
            onClick={(event) => {
              event.stopPropagation();
              setModalContent(
                <EntityNotes
                  entityType={ENTITY_TYPE.PARTICIPANT}
                  entityId={participantId}
                />,
              );
            }}
            badgeContent={notes?.length}
            color="primary"
          >
            <IconButton>
              <Comment />
            </IconButton>
          </StyledBadge>
        </Tooltip>
      </MembersOnlyJacket>
    )
  );
}
